// import React, { useEffect, useRef } from 'react';
// import styled from 'styled-components';
// import { motion, useAnimation, useInView } from 'framer-motion';
// import { FaLaptopCode, FaMobileAlt, FaCloud, FaShieldAlt, FaUsers, FaLightbulb, FaChartLine, FaCogs, FaRobot, FaCar, FaWarehouse, FaBook, FaFileAlt, FaHospital, FaStreetView, FaGraduationCap, FaBriefcase, FaBuilding, FaGlobe } from 'react-icons/fa';
// import { useHistory } from 'react-router-dom';

// const fadeInUp = {
//     hidden: { opacity: 0, y: 20 },
//     visible: {
//         opacity: 1,
//         y: 0,
//         transition: {
//             duration: 0.5
//         }
//     }
// };

// const bounce = {
//     hidden: { y: 0 },
//     visible: {
//         y: [0, -10, 0],
//         transition: {
//             duration: 1.5,
//             repeat: Infinity,
//             repeatType: "loop"
//         }
//     }
// };

// const scrollLine = {
//     hidden: { transform: "scaleY(0)" },
//     visible: {
//         transform: "scaleY(1)",
//         transition: {
//             duration: 1,
//             repeat: Infinity,
//             repeatType: "loop"
//         }
//     }
// };

// const HomeContainer = styled.div`
//   padding: 0;
//   background: #FFFFFF;
//   color: #333333;
//   font-family: 'Inter', 'Segoe UI', 'Arial', sans-serif;
//   min-height: 100vh;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   position: relative;
//   overflow-x: hidden;
// `;

// const HeroSection = styled(motion.section)`
//   width: 100%;
//   min-height: 100vh;
//   background: linear-gradient(135deg, #0A2342, #005f56);
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   text-align: center;
//   padding: 4rem 2rem;
//   position: relative;
//   overflow: hidden;

//   &::before {
//     content: "";
//     position: absolute;
//     top: 0;
//     left: 0;
//     right: 0;
//     bottom: 0;
//     background-blend-mode: overlay;
//     opacity: 0.1;
//     background-image: radial-gradient(#ffffff 1px, transparent 1px);
//     background-size: 10px 10px;
//   }

//   &::after {
//   }
// `;

// const HeroContent = styled(motion.div)`
//   position: relative;
//   z-index: 2;
//   max-width: 1200px;
//   margin: 0 auto;
//   padding: 2rem;
// `;

// const Title = styled(motion.h1)`
//   font-size: 4.2rem;
//   margin-bottom: 1rem;
//   color: #F4F4F4;
//   font-weight: 800;
//   line-height: 1.2;
//   text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);

//   span {
//     display: block;
//     font-size: 0.5em;
//     color: #FFC857;
//     margin-top: 0.5rem;
//     font-weight: 600;
//     letter-spacing: 3px;
//     text-transform: uppercase;
//   }

//   @media (max-width: 768px) {
//     font-size: 2.8rem;
//   }
// `;

// const Subtitle = styled(motion.p)`
//   font-size: 1.6rem;
//   color: rgba(244, 244, 244, 0.9);
//   margin: 0 auto 3rem;
//   max-width: 800px;
//   line-height: 1.6;
//   font-weight: 300;
//   text-align: center;
//   padding: 0 2rem;
//   text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);

//   @media (max-width: 768px) {
//     font-size: 1.3rem;
//     padding: 0 1rem;
//   }
// `;

// const FeaturesGrid = styled(motion.div)`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
//   gap: 2.5rem;
//   margin: 3rem 0;
//   max-width: 1100px;
// `;

// const Feature = styled(motion.div)`
//   background: rgba(255, 255, 255, 0.08);
//   backdrop-filter: blur(8px);
//   padding: 2.5rem;
//   border-radius: 15px;
//   border: 1px solid rgba(255, 255, 255, 0.1);
//   transition: all 0.3s ease;

//   &:hover {
//     transform: translateY(-5px);
//     background: rgba(255, 255, 255, 0.12);
//     box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
//     border-color: rgba(255, 255, 255, 0.2);
//   }

//   h3 {
//     color: #FFC857;
//     margin-bottom: 1.2rem;
//     font-size: 1.4rem;
//     font-weight: 600;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     gap: 0.8rem;
//   }

//   p {
//     color: rgba(244, 244, 244, 0.85);
//     font-size: 1rem;
//     margin: 0;
//     line-height: 1.6;
//     font-weight: 300;
//   }
// `;

// const CTAButton = styled(motion.a)`
//   background: linear-gradient(135deg, #FFC857, #FF9F1C);
//   color: #0A2342;
//   padding: 1.1rem 3rem;
//   border-radius: 50px;
//   text-decoration: none;
//   font-weight: 600;
//   font-size: 1.1rem;
//   transition: all 0.3s ease;
//   box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
//   position: relative;
//   overflow: hidden;
//   display: inline-flex;
//   align-items: center;
//   gap: 0.8rem;
//   margin-top: 2.5rem;
//   letter-spacing: 0.5px;
//   border: none;

//   svg {
//     transition: transform 0.3s ease;
//   }

//   &:hover {
//     transform: translateY(-3px);
//     box-shadow: 0 6px 20px rgba(255, 200, 87, 0.4);
//     background: linear-gradient(135deg, #FF9F1C, #FFC857);

//     svg {
//       transform: translateX(5px);
//     }
//   }
// `;

// const ScrollIndicator = styled(motion.div)`
//   position: absolute;
//   bottom: 2rem;
//   left: 50%;
//   transform: translateX(-50%);
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   color: #F4F4F4;
//   opacity: 0.7;

//   span {
//     font-size: 0.8rem;
//     margin-bottom: 0.5rem;
//   }

//   &::after {
//     content: '';
//     width: 2px;
//     height: 30px;
//     background: #F4F4F4;
//   }
// `;

// const Section = styled(motion.section)`
//   padding: 5rem 2rem;
//   max-width: 1200px;
//   width: 100%;
//   margin: 0 auto;
//   position: relative;
//   overflow: hidden;

//   &:nth-child(even) {
//     background: #F8F9FA;
//   }
//   &:nth-child(odd) {
//     background: #FFFFFF;
//   }
// `;

// const SectionTitle = styled(motion.h2)`
//   font-size: 2.5rem;
//   color: #0A2342;
//   margin-bottom: 3rem;
//   text-align: center;
//   position: relative;
//   font-weight: 700;

//   &::after {
//     content: '';
//     position: absolute;
//     bottom: -15px;
//     left: 50%;
//     transform: translateX(-50%);
//     width: 80px;
//     height: 4px;
//     background: linear-gradient(to right, #0A2342, #00A896);
//     border-radius: 2px;
//   }
// `;

// const AboutContent = styled(motion.div)`
//   display: grid;
//   grid-template-columns: 1fr 1fr;
//   gap: 4rem;
//   align-items: center;
//   margin-top: 4rem;

//   @media (max-width: 768px) {
//     grid-template-columns: 1fr;
//     gap: 2rem;
//   }
// `;

// const AboutText = styled(motion.div)`
//   p {
//     font-size: 1.1rem;
//     line-height: 1.8;
//     color: #333333;
//     margin-bottom: 1.5rem;

//     &:last-child {
//       margin-bottom: 0;
//     }

//     strong {
//       color: #0A2342;
//       font-weight: 600;
//     }

//     em {
//       color: #00A896;
//       font-style: normal;
//       font-weight: 500;
//     }
//   }
// `;

// const AboutImage = styled(motion.div)`
//   position: relative;
//   height: auto;
//   aspect-ratio: 4 / 3;
//   border-radius: 15px;
//   overflow: hidden;
//   box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);

//   img {
//     width: 100%;
//     height: 100%;
//     object-fit: cover;
//     transition: transform 0.5s ease;
//     display: block;
//   }

//   &:hover {
//     img {
//       transform: scale(1.05);
//     }
//   }
// `;

// const Tagline = styled(motion.div)`
//   background: linear-gradient(135deg, #0A2342, #005f56);
//   color: #F4F4F4;
//   padding: 2.5rem;
//   border-radius: 10px;
//   margin-top: 4rem;
//   text-align: center;
//   box-shadow: 0 6px 20px rgba(10, 35, 66, 0.2);

//   h3 {
//     font-size: 1.8rem;
//     margin-bottom: 1rem;
//     font-weight: 600;
//   }

//   p {
//     font-size: 1.2rem;
//     opacity: 0.9;
//     margin: 0;
//     font-weight: 300;
//   }
// `;

// const ProductsSection = styled(motion.section)`
//   padding: 6rem 2rem;
//   background: #f8f9fa;
//   position: relative;
//   overflow: hidden;
//   width: 100%;
//   max-width: 100%;
//   margin: 0;
// `;

// const ProductsGrid = styled(motion.div)`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
//   gap: 2.5rem;
//   margin-top: 4rem;
//   padding: 0 2rem;
//   max-width: 1200px;
//   margin: 2rem auto;
//   position: relative;
//   z-index: 2;
// `;

// const ProductCard = styled(motion.div)`
//   background: #ffffff;
//   border-radius: 6px;
//   padding: 1.5rem;
//   box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
//   transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//   position: relative;
//   overflow: hidden;
//   height: 100%;
//   display: flex;
//   flex-direction: column;
//   border: 1px solid rgba(0, 0, 0, 0.02);
//   margin: 0.3rem;

//   &::before {
//     content: '';
//     position: absolute;
//     top: 0;
//     left: 0;
//     width: 100%;
//     height: 2px;
//     background: ${props => {
//       if (props.className?.includes('management')) return '#00A896';
//       if (props.className?.includes('tracking')) return '#FF6B6B';
//       if (props.className?.includes('ai')) return '#4ECDC4';
//       if (props.className?.includes('library')) return '#FFD166';
//       if (props.className?.includes('healthcare')) return '#6A0572';
//       return '#00A896';
//     }};
//   }

//   .category-badge {
//     position: absolute;
//     top: 0.8rem;
//     right: 0.8rem;
//     background: ${props => {
//       if (props.className?.includes('management')) return 'rgba(0, 168, 150, 0.08)';
//       if (props.className?.includes('tracking')) return 'rgba(255, 107, 107, 0.08)';
//       if (props.className?.includes('ai')) return 'rgba(78, 205, 196, 0.08)';
//       if (props.className?.includes('library')) return 'rgba(255, 209, 102, 0.08)';
//       if (props.className?.includes('healthcare')) return 'rgba(106, 5, 114, 0.08)';
//       return 'rgba(0, 168, 150, 0.08)';
//     }};
//     color: ${props => {
//       if (props.className?.includes('management')) return '#00A896';
//       if (props.className?.includes('tracking')) return '#FF6B6B';
//       if (props.className?.includes('ai')) return '#4ECDC4';
//       if (props.className?.includes('library')) return '#FFD166';
//       if (props.className?.includes('healthcare')) return '#6A0572';
//       return '#00A896';
//     }};
//     padding: 0.2rem 0.6rem;
//     border-radius: 10px;
//     font-size: 0.65rem;
//     font-weight: 600;
//     text-transform: uppercase;
//     letter-spacing: 0.7px;
//     border: 1px solid currentColor;
//     opacity: 0.8;
//   }

//   &:hover {
//     transform: translateY(-2px);
//     box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);

//     .icon {
//       transform: scale(1.05);
//       color: ${props => {
//         if (props.className?.includes('management')) return '#00A896';
//         if (props.className?.includes('tracking')) return '#FF6B6B';
//         if (props.className?.includes('ai')) return '#4ECDC4';
//         if (props.className?.includes('library')) return '#FFD166';
//         if (props.className?.includes('healthcare')) return '#6A0572';
//         return '#00A896';
//       }};
//     }

//     .product-title {
//       color: ${props => {
//         if (props.className?.includes('management')) return '#00A896';
//         if (props.className?.includes('tracking')) return '#FF6B6B';
//         if (props.className?.includes('ai')) return '#4ECDC4';
//         if (props.className?.includes('library')) return '#FFD166';
//         if (props.className?.includes('healthcare')) return '#6A0572';
//         return '#00A896';
//       }};
//     }
//   }
// `;

// const ProductIcon = styled.div`
//   font-size: 2rem;
//   color: #333;
//   margin-bottom: 1rem;
//   transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//   text-align: center;
//   opacity: 0.9;
// `;

// const ProductTitle = styled.h3`
//   color: #333;
//   font-size: 1.1rem;
//   margin-bottom: 0.7rem;
//   font-weight: 600;
//   text-align: center;
//   transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//   letter-spacing: -0.2px;
// `;

// const ProductDescription = styled.p`
//   color: #666;
//   line-height: 1.5;
//   font-size: 0.85rem;
//   text-align: center;
//   flex-grow: 1;
//   opacity: 0.8;
// `;

// const SectionHeader = styled(motion.div)`
//   text-align: center;
//   margin-bottom: 2rem;
//   position: relative;
//   z-index: 2;
//   max-width: 700px;
//   margin: 0 auto 3rem;
//   padding: 0 2rem;

//   h2 {
//     font-size: 2.2rem;
//     color: #333;
//     margin-bottom: 0.8rem;
//     font-weight: 700;
//     position: relative;
//     display: inline-block;
//     letter-spacing: -0.5px;

//     &::after {
//       content: '';
//       position: absolute;
//       bottom: -8px;
//       left: 50%;
//       transform: translateX(-50%);
//       width: 35px;
//       height: 2px;
//       background: #00A896;
//       border-radius: 1px;
//     }
//   }

//   p {
//     color: #666;
//     font-size: 1rem;
//     line-height: 1.5;
//     opacity: 0.8;
//   }
// `;

// const ServicesGrid = styled(motion.div)`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
//   gap: 2.5rem;
//   margin-top: 4rem;
// `;

// const ServiceCard = styled(motion.div)`
//   background: #FFFFFF;
//   padding: 2.5rem;
//   border-radius: 10px;
//   box-shadow: 0 5px 15px rgba(0, 0, 0, 0.07);
//   transition: all 0.3s ease;
//   border-top: 4px solid #00A896;

//   &:hover {
//     transform: translateY(-5px) scale(1.02);
//     box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);

//     .icon {
//       transform: scale(1.1) rotate(5deg);
//     }
//   }

//   h3 {
//     color: #0A2342;
//     margin-bottom: 1rem;
//     font-size: 1.4rem;
//     font-weight: 600;
//     display: flex;
//     align-items: center;
//     gap: 1rem;
//   }

//   p {
//     color: #555555;
//     line-height: 1.7;
//     font-size: 1rem;
//   }
// `;

// const ServiceIcon = styled.div`
//   font-size: 2rem;
//   color: #00A896;
//   transition: all 0.3s ease;
// `;

// const ContactForm = styled(motion.form)`
//   max-width: 700px;
//   margin: 4rem auto 0;
//   padding: 3rem;
//   background: #FFFFFF;
//   border-radius: 10px;
//   box-shadow: 0 5px 15px rgba(0, 0, 0, 0.07);
//   border-top: 4px solid #0A2342;

//   input, textarea {
//     width: 100%;
//     padding: 1rem;
//     margin-bottom: 1.5rem;
//     border: 1px solid #ddd;
//     border-radius: 6px;
//     font-size: 1rem;
//     transition: all 0.3s ease;
//     color: #333333;

//     &:focus {
//       outline: none;
//       border-color: #00A896;
//       box-shadow: 0 0 0 3px rgba(0, 168, 150, 0.2);
//     }
//   }

//   textarea {
//     min-height: 150px;
//     resize: vertical;
//   }

//   button {
//     background: linear-gradient(135deg, #0A2342, #005f56);
//     color: #F4F4F4;
//     padding: 1rem 2.5rem;
//     border: none;
//     border-radius: 50px;
//     font-size: 1.1rem;
//     font-weight: 600;
//     cursor: pointer;
//     transition: all 0.3s ease;
//     display: block;
//     margin: 1rem auto 0;

//     &:hover {
//       transform: translateY(-3px);
//       box-shadow: 0 6px 20px rgba(10, 35, 66, 0.3);
//       filter: brightness(1.1);
//     }
//   }
// `;

// const productSlugs = [
//   'attendance-management-system',
//   'vehicle-tracking-system',
//   'vehicle-workshop-management-system',
//   'face-recognition-ai',
//   'e-scrap',
//   'inventory-management-system',
//   'advertisement-management-system',
//   'digital-academic-system',
//   'asset-management-system',
//   'pole-street-light-management',
//   'digital-library',
//   'workflow-management-system',
//   'document-management-system',
//   'opac',
//   'health-management-system'
// ];

// const Home = () => {
//     const controls = useAnimation();
//     const ref = useRef(null);
//     const isInView = useInView(ref, { once: true });
//     const history = useHistory();

//     useEffect(() => {
//         if (isInView) {
//             controls.start("visible");
//         }
//     }, [isInView, controls]);

//     const containerVariants = {
//         hidden: { opacity: 0 },
//         visible: {
//             opacity: 1,
//             transition: {
//                 staggerChildren: 0.3
//             }
//         }
//     };

//     const itemVariants = {
//         hidden: { opacity: 0, y: 20 },
//         visible: {
//             opacity: 1,
//             y: 0,
//             transition: {
//                 duration: 0.5
//             }
//         }
//     };

//     const scaleIn = {
//         hidden: { opacity: 0, scale: 0.8 },
//         visible: {
//             opacity: 1,
//             scale: 1,
//             transition: {
//                 duration: 0.5
//             }
//         }
//     };

//     return (
//         <HomeContainer>
//             <HeroSection
//                 initial={{ opacity: 0 }}
//                 animate={{ opacity: 1 }}
//                 transition={{ duration: 1 }}
//             >
//                 <HeroContent
//                     variants={containerVariants}
//                     initial="hidden"
//                     animate="visible"
//                 >
//                     <Title variants={itemVariants}>
//                         VVV IT Solutions
//                         <span>Excellence in Digital Innovation</span>
//                     </Title>
//                     <Subtitle variants={itemVariants}>
//                         Transforming businesses through cutting-edge technology solutions and expert software development services
//                     </Subtitle>

//                     <FeaturesGrid variants={containerVariants}>
//                         <Feature variants={itemVariants}>
//                             <h3><FaLaptopCode /> Enterprise Solutions</h3>
//                             <p>Comprehensive software solutions for large-scale operations and government projects</p>
//                         </Feature>
//                         <Feature variants={itemVariants}>
//                             <h3><FaGlobe /> Digital Transformation</h3>
//                             <p>Modernizing businesses with innovative technology and automation solutions</p>
//                         </Feature>
//                         <Feature variants={itemVariants}>
//                             <h3><FaUsers /> Expert Support</h3>
//                             <p>Round-the-clock technical assistance and dedicated project management</p>
//                         </Feature>
//                     </FeaturesGrid>

//                     <CTAButton
//                         variants={itemVariants}
//                         whileHover={{ scale: 1.05 }}
//                         whileTap={{ scale: 0.95 }}
//                         href="#contact"
//                     >
//                         Begin Your Digital Journey
//                         <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                             <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
//                         </svg>
//                     </CTAButton>
//                 </HeroContent>
//                 <ScrollIndicator
//                     animate={controls}
//                     variants={bounce}
//                 >
//                     <span>Explore Our Services</span>
//                 </ScrollIndicator>
//             </HeroSection>

//             <Section
//                 id="about"
//                 ref={ref}
//                 variants={containerVariants}
//                 initial="hidden"
//                 animate={controls}
//             >
//                 <SectionTitle variants={fadeInUp}>About Us</SectionTitle>
//                 <AboutContent>
//                     <AboutText variants={fadeInUp}>
//                         <p>
//                             At <strong>VVV IT Solutions Pvt. Ltd.</strong>, we believe in transforming ideas into intelligent digital solutions. Established with a vision to drive innovation through automation, VVV has emerged as a trusted name in the field of software development, particularly in government and enterprise-level projects.
//                         </p>
//                         <p>
//                             Our expertise spans across a wide array of domains, including vehicle tracking systems, smart attendance solutions, advertisement management, and digital library systems. With a dedicated team of developers, designers, and project managers, we deliver custom-built software that is secure, scalable, and user-friendly.
//                         </p>
//                         <p>
//                             Backed by a deep understanding of industry needs and a commitment to technological excellence, we continuously strive to empower institutions through <em>digital transformation</em>. Every solution we build is crafted with precision, keeping in mind the unique goals of our clients.
//                         </p>
//                     </AboutText>
//                     <AboutImage
//                         variants={scaleIn}
//                         whileHover={{ scale: 1.05 }}
//                     >
//                         <img src="/images/HeroImage.jpg" alt="About VVV IT Solutions" />
//                     </AboutImage>
//                 </AboutContent>
//                 <Tagline variants={fadeInUp}>
//                     <h3>Our Promise</h3>
//                     <p>"A World of Automation" is not just a tagline—it's our commitment to creating smart, efficient, and future-ready solutions.</p>
//                 </Tagline>
//             </Section>

//             <ProductsSection
//                 variants={containerVariants}
//                 initial="hidden"
//                 whileInView="visible"
//                 viewport={{ once: true }}
//             >
//                 <SectionHeader variants={fadeInUp}>
//                     <h2>Software Products</h2>
//                     <p>Innovative solutions designed to transform your business operations</p>
//                 </SectionHeader>
//                 <ProductsGrid>
//                     {[
//                         {
//                             icon: <FaUsers />,
//                             title: "Attendance Management System",
//                             description: "Automates attendance using Face Recognition, Biometric, and RFID technologies for efficient workforce management.",
//                             category: "management"
//                         },
//                         {
//                             icon: <FaCar />,
//                             title: "Vehicle Tracking System (VTS)",
//                             description: "Real-time vehicle tracking solution for route optimization and timely delivery management.",
//                             category: "tracking"
//                         },
//                         {
//                             icon: <FaCogs />,
//                             title: "Vehicle Workshop Management System (VWMS)",
//                             description: "Streamlines repairs, inventory, and workshop management for automotive businesses.",
//                             category: "management"
//                         },
//                         {
//                             icon: <FaRobot />,
//                             title: "Face Recognition and Detection Using AI",
//                             description: "Advanced AI-powered solution for facial identification and verification applications.",
//                             category: "ai"
//                         },
//                         {
//                             icon: <FaWarehouse />,
//                             title: "e-Scrap (Landfill Automation)",
//                             description: "Optimizes scrap handling and tracking in industrial environments for better resource management.",
//                             category: "management"
//                         },
//                         {
//                             icon: <FaChartLine />,
//                             title: "Inventory Management System",
//                             description: "Comprehensive solution with GIS mapping and real-time visibility for efficient inventory control.",
//                             category: "management"
//                         },
//                         {
//                             icon: <FaLightbulb />,
//                             title: "Advertisement Management System",
//                             description: "Automates planning and execution of advertising campaigns for better marketing efficiency.",
//                             category: "management"
//                         },
//                         {
//                             icon: <FaGraduationCap />,
//                             title: "Digital Academic System (DAS-ERP)",
//                             description: "ERP solution designed for optimizing organizational processes in educational institutions.",
//                             category: "management"
//                         },
//                         {
//                             icon: <FaBuilding />,
//                             title: "Asset Management System (RFID)",
//                             description: "Advanced tracking and management system using RFID and GIS mapping technologies.",
//                             category: "tracking"
//                         },
//                         {
//                             icon: <FaStreetView />,
//                             title: "Pole and Street Light Management System",
//                             description: "Efficient management of street light inventory and operational status monitoring.",
//                             category: "management"
//                         },
//                         {
//                             icon: <FaBook />,
//                             title: "Digital Library / e-Library",
//                             description: "Transforms traditional libraries into versatile digital spaces for modern learning.",
//                             category: "library"
//                         },
//                         {
//                             icon: <FaFileAlt />,
//                             title: "Workflow Management System",
//                             description: "Centralized management solution for documents and workflows in organizations.",
//                             category: "management"
//                         },
//                         {
//                             icon: <FaFileAlt />,
//                             title: "Document Management System (DMS)",
//                             description: "Efficient system for streamlined storage and retrieval of digital documents.",
//                             category: "management"
//                         },
//                         {
//                             icon: <FaBook />,
//                             title: "OPAC",
//                             description: "Web-based tool for libraries to provide easy access to their collections.",
//                             category: "library"
//                         },
//                         {
//                             icon: <FaHospital />,
//                             title: "Health Management System",
//                             description: "Comprehensive solution for streamlining healthcare facility and patient care management.",
//                             category: "healthcare"
//                         }
//                     ].map((product, index) => (
//                         <button
//                             key={index}
//                             style={{
//                                 background: 'none',
//                                 border: 'none',
//                                 padding: 0,
//                                 margin: 0,
//                                 width: '100%',
//                                 textAlign: 'inherit',
//                                 cursor: 'pointer',
//                                 outline: 'none',
//                             }}
//                             onClick={() => history.push(`/products/${productSlugs[index]}`)}
//                         >
//                             <ProductCard
//                                 variants={itemVariants}
//                                 whileHover={{ y: -2 }}
//                                 transition={{ delay: index * 0.1 }}
//                                 className={product.category}
//                             >
//                                 <div className="category-badge">
//                                     {product.category.charAt(0).toUpperCase() + product.category.slice(1)}
//                                 </div>
//                                 <ProductIcon className={`icon ${product.category}`}>{product.icon}</ProductIcon>
//                                 <ProductTitle className={`product-title ${product.category}`}>{product.title}</ProductTitle>
//                                 <ProductDescription>{product.description}</ProductDescription>
//                             </ProductCard>
//                         </button>
//                     ))}
//                 </ProductsGrid>
//             </ProductsSection>

//             <Section
//                 id="services"
//                 variants={containerVariants}
//                 initial="hidden"
//                 whileInView="visible"
//                 viewport={{ once: true }}
//             >
//                 <SectionTitle variants={fadeInUp}>Our Services</SectionTitle>
//                 <ServicesGrid>
//                     {[
//                         { icon: <FaLaptopCode />, title: "Custom Software Development", description: "Tailored solutions designed to meet your specific business needs and challenges." },
//                         { icon: <FaGlobe />, title: "Web Development", description: "Modern, responsive websites that engage users and drive business growth." },
//                         { icon: <FaMobileAlt />, title: "Mobile App Development", description: "Native and cross-platform mobile applications for iOS and Android." }
//                     ].map((service, index) => (
//                         <ServiceCard
//                             key={index}
//                             variants={itemVariants}
//                             whileHover={{ y: -5 }}
//                             transition={{ delay: index * 0.1 }}
//                         >
//                             <h3><ServiceIcon className="icon">{service.icon}</ServiceIcon> {service.title}</h3>
//                             <p>{service.description}</p>
//                         </ServiceCard>
//                     ))}
//                 </ServicesGrid>
//             </Section>

//             <Section
//                 id="contact"
//                 variants={containerVariants}
//                 initial="hidden"
//                 whileInView="visible"
//                 viewport={{ once: true }}
//             >
//                 <SectionTitle variants={fadeInUp}>Contact Us</SectionTitle>
//                 <ContactForm variants={fadeInUp}>
//                     <input type="text" placeholder="Your Name" required />
//                     <input type="email" placeholder="Your Email" required />
//                     <input type="text" placeholder="Subject" required />
//                     <textarea placeholder="Your Message" required></textarea>
//                     <motion.button
//                         whileHover={{ scale: 1.05 }}
//                         whileTap={{ scale: 0.95 }}
//                         type="submit"
//                     >
//                         Send Message
//                     </motion.button>
//                 </ContactForm>
//             </Section>
//         </HomeContainer>
//     );
// };

// export default Home;

import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { motion, useAnimation, useInView } from "framer-motion";
import {
  FaLaptopCode,
  FaMobileAlt,
  FaCloud,
  FaShieldAlt,
  FaUsers,
  FaLightbulb,
  FaChartLine,
  FaCogs,
  FaRobot,
  FaCar,
  FaWarehouse,
  FaBook,
  FaFileAlt,
  FaHospital,
  FaStreetView,
  FaGraduationCap,
  FaBriefcase,
  FaBuilding,
  FaGlobe,
} from "react-icons/fa";
import { useHistory } from "react-router-dom";

import companyFounder from "./images/companyfounder.png";
const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
    },
  },
};

const bounce = {
  hidden: { y: 0 },
  visible: {
    y: [0, -10, 0],
    transition: {
      duration: 1.5,
      repeat: Infinity,
      repeatType: "loop",
    },
  },
};

const scrollLine = {
  hidden: { transform: "scaleY(0)" },
  visible: {
    transform: "scaleY(1)",
    transition: {
      duration: 1,
      repeat: Infinity,
      repeatType: "loop",
    },
  },
};

const HomeContainer = styled.div`
  padding: 0;
  background: #ffffff;
  color: #333333;
  font-family: "Inter", "Segoe UI", "Arial", sans-serif;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow-x: hidden;
  margin-top: 80px; /* Add space for fixed header */

  @media (max-width: 768px) {
    margin-top: 70px; /* Adjust for mobile header */
    font-size: 0.9rem;
  }

  @media (max-width: 480px) {
    margin-top: 60px; /* Further adjustment for small mobile */
  }
`;

const HeroSection = styled(motion.section)`
  width: 100%;
  min-height: calc(100vh - 80px); /* Account for header space */
  background: linear-gradient(135deg, var(--theme-hero-start), var(--theme-hero-end));
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 4rem 1rem;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-blend-mode: overlay;
    opacity: 0.1;
    background-image: radial-gradient(#ffffff 1px, transparent 1px);
    background-size: 10px 10px;
  }

  @media (max-width: 768px) {
    padding: 3rem 1rem;
    min-height: calc(80vh - 70px);
    padding-top: 2rem; /* Extra padding for mobile */
  }

  @media (max-width: 480px) {
    padding: 2rem 0.5rem;
    min-height: calc(80vh - 60px);
    padding-top: 1.5rem; /* Extra padding for small mobile */
  }
`;

const HeroContent = styled(motion.div)`
  position: relative;
  z-index: 2;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  width: 100%;

  @media (max-width: 768px) {
    padding: 1.5rem;
  }

  @media (max-width: 480px) {
    padding: 1rem 0.5rem; /* Reduced side padding for mobile */
  }
`;

const Title = styled(motion.h1)`
  font-size: 4.2rem;
  margin-bottom: 1rem;
  color: #f4f4f4;
  font-weight: 800;
  line-height: 1.2;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  word-wrap: break-word;
  overflow-wrap: break-word;
  padding: 0 1rem; /* Add padding to prevent cutoff */

  span {
    display: block;
    font-size: 0.5em;
    color: #ffc857;
    margin-top: 0.5rem;
    font-weight: 600;
    letter-spacing: 3px;
    text-transform: uppercase;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  @media (max-width: 1024px) {
    font-size: 3.5rem;
    padding: 0 1rem;
  }

  @media (max-width: 768px) {
    font-size: 2.8rem;
    padding: 0 0.5rem;
    line-height: 1.3;
  }

  @media (max-width: 480px) {
    font-size: 2rem; /* Further reduced for mobile */
    padding: 0 0.25rem;
    line-height: 1.4;
    margin-bottom: 0.5rem;

    span {
      font-size: 0.45em; /* Adjust subtitle size */
      letter-spacing: 2px;
      margin-top: 0.3rem;
    }
  }

  @media (max-width: 360px) {
    font-size: 1.8rem; /* Extra small mobile adjustment */

    span {
      font-size: 0.4em;
      letter-spacing: 1px;
    }
  }
`;

const Subtitle = styled(motion.p)`
  font-size: 1.6rem;
  color: rgba(244, 244, 244, 0.9);
  margin: 0 auto 3rem;
  max-width: 800px;
  line-height: 1.6;
  font-weight: 300;
  text-align: center;
  padding: 0 2rem;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
  word-wrap: break-word;
  overflow-wrap: break-word;

  @media (max-width: 1024px) {
    font-size: 1.4rem;
    max-width: 700px;
  }

  @media (max-width: 768px) {
    font-size: 1.3rem;
    padding: 0 1rem;
    margin-bottom: 2rem;
  }

  @media (max-width: 480px) {
    font-size: 1rem; /* Reduced for mobile */
    padding: 0 0.5rem;
    margin-bottom: 1.5rem;
    line-height: 1.5;
  }

  @media (max-width: 360px) {
    font-size: 0.9rem; /* Extra small mobile adjustment */
    padding: 0 0.25rem;
  }
`;

const FeaturesGrid = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2.5rem;
  margin: 3rem 0;
  max-width: 1100px;
  padding: 0 1rem;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    margin: 2rem 0;
  }

  @media (max-width: 480px) {
    gap: 1rem;
    margin: 1.5rem 0;
    padding: 0 0.5rem;
  }
`;

const Feature = styled(motion.div)`
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(8px);
  padding: 2.5rem;
  border-radius: 15px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    background: rgba(255, 255, 255, 0.12);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
    border-color: rgba(255, 255, 255, 0.2);
  }

  h3 {
    color: #ffc857;
    margin-bottom: 1.2rem;
    font-size: 1.4rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.8rem;
    word-wrap: break-word;
  }

  p {
    color: rgba(244, 244, 244, 0.85);
    font-size: 1rem;
    margin: 0;
    line-height: 1.6;
    font-weight: 300;
    word-wrap: break-word;
  }

  @media (max-width: 768px) {
    padding: 2rem;
  }

  @media (max-width: 480px) {
    padding: 1.5rem;

    h3 {
      font-size: 1.2rem;
      flex-direction: column;
      gap: 0.5rem;
    }

    p {
      font-size: 0.9rem;
    }
  }
`;

const CTAButton = styled(motion.a)`
  background: linear-gradient(135deg, #ffc857, #ff9f1c);
  color: var(--theme-primary);
  padding: 1.1rem 3rem;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  position: relative;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  gap: 0.8rem;
  margin-top: 2.5rem;
  letter-spacing: 0.5px;
  border: none;

  svg {
    transition: transform 0.3s ease;
  }

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 20px rgba(255, 200, 87, 0.4);
    background: linear-gradient(135deg, #ff9f1c, #ffc857);

    svg {
      transform: translateX(5px);
    }
  }

  @media (max-width: 768px) {
    padding: 1rem 2.5rem;
    font-size: 1rem;
    margin-top: 2rem;
  }

  @media (max-width: 480px) {
    padding: 0.8rem 2rem;
    font-size: 0.9rem;
    margin-top: 1.5rem;
  }
`;

const ScrollIndicator = styled(motion.div)`
  position: absolute;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #f4f4f4;
  opacity: 0.7;

  span {
    font-size: 0.8rem;
    margin-bottom: 0.5rem;
  }

  &::after {
    content: "";
    width: 2px;
    height: 30px;
    background: #f4f4f4;
  }

  @media (max-width: 480px) {
    bottom: 1rem;

    span {
      font-size: 0.7rem;
    }

    &::after {
      height: 20px;
    }
  }
`;

const Section = styled(motion.section)`
  padding: 5rem 2rem;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  position: relative;
  overflow: hidden;

  &:nth-child(even) {
    background: #f8f9fa;
  }
  &:nth-child(odd) {
    background: #ffffff;
  }

  @media (max-width: 1024px) {
    padding: 4rem 1.5rem;
  }

  @media (max-width: 768px) {
    padding: 3rem 1rem;
  }

  @media (max-width: 480px) {
    padding: 2rem 0.5rem;
  }
`;

const SectionTitle = styled(motion.h2)`
  font-size: 2.5rem;
  color: var(--theme-primary);
  margin-bottom: 3rem;
  text-align: center;
  position: relative;
  font-weight: 700;

  &::after {
    content: "";
    position: absolute;
    bottom: -15px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 4px;
    background: linear-gradient(to right, var(--theme-primary), var(--theme-accent));
    border-radius: 2px;
  }

  @media (max-width: 1024px) {
    font-size: 2.2rem;
    margin-bottom: 2.5rem;
  }

  @media (max-width: 768px) {
    font-size: 2rem;
  }

  @media (max-width: 480px) {
    font-size: 1.8rem;
    margin-bottom: 2rem;
  }
`;

const AboutContent = styled(motion.div)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
  margin-top: 4rem;

  @media (max-width: 1024px) {
    gap: 3rem;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

const AboutText = styled(motion.div)`
  p {
    font-size: 1.1rem;
    line-height: 1.8;
    color: #333333;
    margin-bottom: 1.5rem;

    &:last-child {
      margin-bottom: 0;
    }

    strong {
      color: var(--theme-primary);
      font-weight: 600;
    }

    em {
      color: var(--theme-accent);
      font-style: normal;
      font-weight: 500;
    }
  }

  @media (max-width: 768px) {
    p {
      font-size: 1rem;
    }
  }

  @media (max-width: 480px) {
    p {
      font-size: 0.9rem;
      line-height: 1.6;
    }
  }
`;

const AboutImage = styled(motion.div)`
  position: relative;
  width: 100%;
  max-width: 320px; /* Compact circular size */
  aspect-ratio: 1 / 1; /* Perfect circle */
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  margin: 0 auto; /* Center image */
  background: #ffffff;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover; /* ensures proper fit */
    border-radius: 50%; /* makes image circular */
    transition: transform 0.5s ease;
    display: block;
  }

  &:hover img {
    transform: scale(1.05);
  }

  @media (max-width: 1024px) {
    max-width: 280px;
  }

  @media (max-width: 768px) {
    max-width: 230px;
  }

  @media (max-width: 480px) {
    max-width: 180px;
  }
`;




const Tagline = styled(motion.div)`
  background: linear-gradient(135deg, var(--theme-hero-start), var(--theme-hero-end));
  color: #f4f4f4;
  padding: 2.5rem;
  border-radius: 10px;
  margin-top: 4rem;
  text-align: center;
  box-shadow: 0 6px 20px var(--theme-shadow-accent);

  h3 {
    font-size: 1.8rem;
    margin-bottom: 1rem;
    font-weight: 600;
  }

  p {
    font-size: 1.2rem;
    opacity: 0.9;
    margin: 0;
    font-weight: 300;
  }

  @media (max-width: 1024px) {
    padding: 2rem;
    margin-top: 3rem;
  }

  @media (max-width: 768px) {
    padding: 1.5rem;
    h3 {
      font-size: 1.6rem;
    }
    p {
      font-size: 1.1rem;
    }
  }

  @media (max-width: 480px) {
    padding: 1rem;
    h3 {
      font-size: 1.4rem;
    }
    p {
      font-size: 1rem;
    }
  }
`;

const ProductsSection = styled(motion.section)`
  padding: 6rem 2rem;
  background: #f8f9fa;
  position: relative;
  overflow: hidden;
  width: 100%;
  max-width: 100%;
  margin: 0;

  @media (max-width: 1024px) {
    padding: 5rem 1.5rem;
  }

  @media (max-width: 768px) {
    padding: 4rem 1rem;
  }

  @media (max-width: 480px) {
    padding: 3rem 0.5rem;
  }
`;

const ProductsGrid = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 2.5rem;
  margin-top: 4rem;
  padding: 0 2rem;
  max-width: 1200px;
  margin: 2rem auto;
  position: relative;
  z-index: 2;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 2rem;
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 1.5rem;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`;

const ProductCard = styled(motion.div)`
  background: #ffffff;
  border-radius: 6px;
  padding: 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(0, 0, 0, 0.02);
  margin: 0.3rem;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: ${(props) => {
      if (props.className?.includes("management")) return "var(--theme-accent)";
      if (props.className?.includes("tracking")) return "#FF6B6B";
      if (props.className?.includes("ai")) return "#4ECDC4";
      if (props.className?.includes("library")) return "#FFD166";
      if (props.className?.includes("healthcare")) return "#6A0572";
      return "var(--theme-accent)";
    }};
  }

  .category-badge {
    position: absolute;
    top: 0.8rem;
    right: 0.8rem;
    background: ${(props) => {
      if (props.className?.includes("management"))
        return "var(--theme-accent-soft)";
      if (props.className?.includes("tracking"))
        return "rgba(255, 107, 107, 0.08)";
      if (props.className?.includes("ai")) return "rgba(78, 205, 196, 0.08)";
      if (props.className?.includes("library"))
        return "rgba(255, 209, 102, 0.08)";
      if (props.className?.includes("healthcare"))
        return "rgba(106, 5, 114, 0.08)";
      return "var(--theme-accent-soft)";
    }};
    color: ${(props) => {
      if (props.className?.includes("management")) return "var(--theme-accent)";
      if (props.className?.includes("tracking")) return "#FF6B6B";
      if (props.className?.includes("ai")) return "#4ECDC4";
      if (props.className?.includes("library")) return "#FFD166";
      if (props.className?.includes("healthcare")) return "#6A0572";
      return "var(--theme-accent)";
    }};
    padding: 0.2rem 0.6rem;
    border-radius: 10px;
    font-size: 0.65rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.7px;
    border: 1px solid currentColor;
    opacity: 0.8;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);

    .icon {
      transform: scale(1.05);
      color: ${(props) => {
        if (props.className?.includes("management")) return "var(--theme-accent)";
        if (props.className?.includes("tracking")) return "#FF6B6B";
        if (props.className?.includes("ai")) return "#4ECDC4";
        if (props.className?.includes("library")) return "#FFD166";
        if (props.className?.includes("healthcare")) return "#6A0572";
        return "var(--theme-accent)";
      }};
    }

    .product-title {
      color: ${(props) => {
        if (props.className?.includes("management")) return "var(--theme-accent)";
        if (props.className?.includes("tracking")) return "#FF6B6B";
        if (props.className?.includes("ai")) return "#4ECDC4";
        if (props.className?.includes("library")) return "#FFD166";
        if (props.className?.includes("healthcare")) return "#6A0572";
        return "var(--theme-accent)";
      }};
    }
  }

  @media (max-width: 480px) {
    padding: 1.2rem;
  }
`;

const ProductIcon = styled.div`
  font-size: 2rem;
  color: #333;
  margin-bottom: 1rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-align: center;
  opacity: 0.9;

  @media (max-width: 480px) {
    font-size: 1.8rem;
  }
`;

const ProductTitle = styled.h3`
  color: #333;
  font-size: 1.1rem;
  margin-bottom: 0.7rem;
  font-weight: 600;
  text-align: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  letter-spacing: -0.2px;

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

const ProductDescription = styled.p`
  color: #666;
  line-height: 1.5;
  font-size: 0.85rem;
  text-align: center;
  flex-grow: 1;
  opacity: 0.8;

  @media (max-width: 480px) {
    font-size: 0.8rem;
  }
`;

const SectionHeader = styled(motion.div)`
  text-align: center;
  margin-bottom: 2rem;
  position: relative;
  z-index: 2;
  max-width: 700px;
  margin: 0 auto 3rem;
  padding: 0 2rem;

  h2 {
    font-size: 2.2rem;
    color: #333;
    margin-bottom: 0.8rem;
    font-weight: 700;
    position: relative;
    display: inline-block;
    letter-spacing: -0.5px;

    &::after {
      content: "";
      position: absolute;
      bottom: -8px;
      left: 50%;
      transform: translateX(-50%);
      width: 35px;
      height: 2px;
      background: var(--theme-accent);
      border-radius: 1px;
    }
  }

  p {
    color: #666;
    font-size: 1rem;
    line-height: 1.5;
    opacity: 0.8;
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 2rem;
    }
    p {
      font-size: 0.9rem;
    }
  }

  @media (max-width: 480px) {
    h2 {
      font-size: 1.8rem;
    }
    p {
      font-size: 0.8rem;
    }
  }
`;

const ServicesGrid = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2.5rem;
  margin-top: 4rem;

  @media (max-width: 1024px) {
    gap: 2rem;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

const ServiceCard = styled(motion.div)`
  background: #ffffff;
  padding: 2.5rem;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.07);
  transition: all 0.3s ease;
  border-top: 4px solid var(--theme-accent);

  &:hover {
    transform: translateY(-5px) scale(1.02);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);

    .icon {
      transform: scale(1.1) rotate(5deg);
    }
  }

  h3 {
    color: var(--theme-primary);
    margin-bottom: 1rem;
    font-size: 1.4rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  p {
    color: #555555;
    line-height: 1.7;
    font-size: 1rem;
  }

  @media (max-width: 768px) {
    padding: 2rem;
  }

  @media (max-width: 480px) {
    padding: 1.5rem;
    h3 {
      font-size: 1.2rem;
    }
    p {
      font-size: 0.9rem;
    }
  }
`;

const ServiceIcon = styled.div`
  font-size: 2rem;
  color: var(--theme-accent);
  transition: all 0.3s ease;

  @media (max-width: 480px) {
    font-size: 1.8rem;
  }
`;

const ContactForm = styled(motion.form)`
  max-width: 700px;
  margin: 4rem auto 0;
  padding: 3rem;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.07);
  border-top: 4px solid var(--theme-primary);

  input,
  textarea {
    width: 100%;
    padding: 1rem;
    margin-bottom: 1.5rem;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 1rem;
    transition: all 0.3s ease;
    color: #333333;

    &:focus {
      outline: none;
      border-color: var(--theme-accent);
      box-shadow: 0 0 0 3px var(--theme-accent-soft);
    }
  }

  textarea {
    min-height: 150px;
    resize: vertical;
  }

  button {
    background: linear-gradient(135deg, var(--theme-hero-start), var(--theme-hero-end));
    color: #f4f4f4;
    padding: 1rem 2.5rem;
    border: none;
    border-radius: 50px;
    font-size: 1.1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: block;
    margin: 1rem auto 0;

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 6px 20px var(--theme-shadow-accent);
      filter: brightness(1.1);
    }
  }

  @media (max-width: 1024px) {
    max-width: 600px;
    padding: 2.5rem;
  }

  @media (max-width: 768px) {
    max-width: 500px;
    padding: 2rem;
  }

  @media (max-width: 480px) {
    padding: 1.5rem;
    input,
    textarea {
      padding: 0.8rem;
      font-size: 0.9rem;
    }
    button {
      padding: 0.8rem 2rem;
      font-size: 1rem;
    }
  }
`;

const productSlugs = [
  "attendance-management-system",
  "vehicle-tracking-system",
  "vehicle-workshop-management-system",
  "face-recognition-ai",
  "e-scrap",
  "inventory-management-system",
  "advertisement-management-system",
  "digital-academic-system",
  "asset-management-system",
  "pole-street-light-management",
  "digital-library",
  "workflow-management-system",
  "document-management-system",
  "opac",
  "health-management-system",
];

const Home = () => {
  const controls = useAnimation();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const history = useHistory();

  useEffect(() => {
    if (isInView) {
      controls.start("visible");
    }
  }, [isInView, controls]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
      },
    },
  };

  const scaleIn = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.5,
      },
    },
  };

  return (
    <HomeContainer>
      <HeroSection
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <HeroContent
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <Title variants={itemVariants}>
            VVV IT Solutions
            <span>Excellence in Digital Innovation</span>
          </Title>
          <Subtitle variants={itemVariants}>
            Transforming businesses through cutting-edge technology solutions
            and expert software development services
          </Subtitle>

          <FeaturesGrid variants={containerVariants}>
            <Feature variants={itemVariants}>
              <h3>
                <FaLaptopCode /> Enterprise Solutions
              </h3>
              <p>
                Comprehensive software solutions for large-scale operations and
                government projects
              </p>
            </Feature>
            <Feature variants={itemVariants}>
              <h3>
                <FaGlobe /> Digital Transformation
              </h3>
              <p>
                Modernizing businesses with innovative technology and automation
                solutions
              </p>
            </Feature>
            <Feature variants={itemVariants}>
              <h3>
                <FaUsers /> Expert Support
              </h3>
              <p>
                Round-the-clock technical assistance and dedicated project
                management
              </p>
            </Feature>
          </FeaturesGrid>

          <CTAButton
            variants={itemVariants}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            href="#contact"
          >
            Begin Your Digital Journey
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5 12H19M19 12L12 5M19 12L12 19"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </CTAButton>
        </HeroContent>
        <ScrollIndicator animate={controls} variants={bounce}>
          <span>Explore Our Services</span>
        </ScrollIndicator>
      </HeroSection>

      <Section
        id="about"
        ref={ref}
        variants={containerVariants}
        initial="hidden"
        animate={controls}
      >
        <SectionTitle variants={fadeInUp}>About Us</SectionTitle>
        <AboutContent>
          <AboutText variants={fadeInUp}>
            <p>
              At <strong>VVV IT Solutions Pvt. Ltd.</strong>, we believe in
              transforming ideas into intelligent digital solutions. Established
              with a vision to drive innovation through automation, VVV has
              emerged as a trusted name in the field of software development,
              particularly in government and enterprise-level projects.
            </p>
            <p>
              Our expertise spans across a wide array of domains, including
              vehicle tracking systems, smart attendance solutions,
              advertisement management, and digital library systems. With a
              dedicated team of developers, designers, and project managers, we
              deliver custom-built software that is secure, scalable, and
              user-friendly.
            </p>
            <p>
              Backed by a deep understanding of industry needs and a commitment
              to technological excellence, we continuously strive to empower
              institutions through <em>digital transformation</em>. Every
              solution we build is crafted with precision, keeping in mind the
              unique goals of our clients.
            </p>
          </AboutText>
          <AboutImage variants={scaleIn} whileHover={{ scale: 1.05 }}>
            <img
              src={companyFounder}
              alt="Shiv Naresh - Founder of VVV IT Solutions"
            />
          </AboutImage>
        </AboutContent>
        <Tagline variants={fadeInUp}>
          <h3>Our Promise</h3>
          <p>
            "A World of Automation" is not just a tagline—it's our commitment to
            creating smart, efficient, and future-ready solutions.
          </p>
        </Tagline>
      </Section>

      <ProductsSection
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <SectionHeader variants={fadeInUp}>
          <h2>Software Products</h2>
          <p>
            Innovative solutions designed to transform your business operations
          </p>
        </SectionHeader>
        <ProductsGrid>
          {[
            {
              icon: <FaUsers />,
              title: "Attendance Management System",
              description:
                "Automates attendance using Face Recognition, Biometric, and RFID technologies for efficient workforce management.",
              category: "management",
            },
            {
              icon: <FaCar />,
              title: "Vehicle Tracking System (VTS)",
              description:
                "Real-time vehicle tracking solution for route optimization and timely delivery management.",
              category: "tracking",
            },
            {
              icon: <FaCogs />,
              title: "Vehicle Workshop Management System (VWMS)",
              description:
                "Streamlines repairs, inventory, and workshop management for automotive businesses.",
              category: "management",
            },
            {
              icon: <FaRobot />,
              title: "Face Recognition and Detection Using AI",
              description:
                "Advanced AI-powered solution for facial identification and verification applications.",
              category: "ai",
            },
            {
              icon: <FaWarehouse />,
              title: "e-Scrap (Landfill Automation)",
              description:
                "Optimizes scrap handling and tracking in industrial environments for better resource management.",
              category: "management",
            },
            {
              icon: <FaChartLine />,
              title: "Inventory Management System",
              description:
                "Comprehensive solution with GIS mapping and real-time visibility for efficient inventory control.",
              category: "management",
            },
            {
              icon: <FaLightbulb />,
              title: "Advertisement Management System",
              description:
                "Automates planning and execution of advertising campaigns for better marketing efficiency.",
              category: "management",
            },
            {
              icon: <FaGraduationCap />,
              title: "Digital Academic System (DAS-ERP)",
              description:
                "ERP solution designed for optimizing organizational processes in educational institutions.",
              category: "management",
            },
            {
              icon: <FaBuilding />,
              title: "Asset Management System (RFID)",
              description:
                "Advanced tracking and management system using RFID and GIS mapping technologies.",
              category: "tracking",
            },
            {
              icon: <FaStreetView />,
              title: "Pole and Street Light Management System",
              description:
                "Efficient management of street light inventory and operational status monitoring.",
              category: "management",
            },
            {
              icon: <FaBook />,
              title: "Digital Library / e-Library",
              description:
                "Transforms traditional libraries into versatile digital spaces for modern learning.",
              category: "library",
            },
            {
              icon: <FaFileAlt />,
              title: "Workflow Management System",
              description:
                "Centralized management solution for documents and workflows in organizations.",
              category: "management",
            },
            {
              icon: <FaFileAlt />,
              title: "Document Management System (DMS)",
              description:
                "Efficient system for streamlined storage and retrieval of digital documents.",
              category: "management",
            },
            {
              icon: <FaBook />,
              title: "OPAC",
              description:
                "Web-based tool for libraries to provide easy access to their collections.",
              category: "library",
            },
            {
              icon: <FaHospital />,
              title: "Health Management System",
              description:
                "Comprehensive solution for streamlining healthcare facility and patient care management.",
              category: "healthcare",
            },
          ].map((product, index) => (
            <button
              key={index}
              style={{
                background: "none",
                border: "none",
                padding: 0,
                margin: 0,
                width: "100%",
                textAlign: "inherit",
                cursor: "pointer",
                outline: "none",
              }}
              onClick={() => history.push(`/products/${productSlugs[index]}`)}
            >
              <ProductCard
                variants={itemVariants}
                whileHover={{ y: -2 }}
                transition={{ delay: index * 0.1 }}
                className={product.category}
              >
                <div className="category-badge">
                  {product.category.charAt(0).toUpperCase() +
                    product.category.slice(1)}
                </div>
                <ProductIcon className={`icon ${product.category}`}>
                  {product.icon}
                </ProductIcon>
                <ProductTitle className={`product-title ${product.category}`}>
                  {product.title}
                </ProductTitle>
                <ProductDescription>{product.description}</ProductDescription>
              </ProductCard>
            </button>
          ))}
        </ProductsGrid>
      </ProductsSection>

      <Section
        id="services"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <SectionTitle variants={fadeInUp}>Our Services</SectionTitle>
        <ServicesGrid>
          {[
            {
              icon: <FaLaptopCode />,
              title: "Custom Software Development",
              description:
                "Tailored solutions designed to meet your specific business needs and challenges.",
            },
            {
              icon: <FaGlobe />,
              title: "Web Development",
              description:
                "Modern, responsive websites that engage users and drive business growth.",
            },
            {
              icon: <FaMobileAlt />,
              title: "Mobile App Development",
              description:
                "Native and cross-platform mobile applications for iOS and Android.",
            },
          ].map((service, index) => (
            <ServiceCard
              key={index}
              variants={itemVariants}
              whileHover={{ y: -5 }}
              transition={{ delay: index * 0.1 }}
            >
              <h3>
                <ServiceIcon className="icon">{service.icon}</ServiceIcon>{" "}
                {service.title}
              </h3>
              <p>{service.description}</p>
            </ServiceCard>
          ))}
        </ServicesGrid>
      </Section>

      {/* <Section
        id="contact"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <SectionTitle variants={fadeInUp}>Contact Us</SectionTitle>
        <ContactForm variants={fadeInUp}>
          <input type="text" placeholder="Your Name" required />
          <input type="email" placeholder="Your Email" required />
          <input type="text" placeholder="Subject" required />
          <textarea placeholder="Your Message" required></textarea>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            type="submit"
          >
            Send Message
          </motion.button>
        </ContactForm>
      </Section> */}
    </HomeContainer>
  );
};

export default Home;
